import { Popover as MantinePopover } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import { OVERLAY_FIT_MIDDLEWARES } from "./popover.constants";
import styles from "./popover.module.scss";
import type { CustomPopoverFactory, IProps } from "./popover.types";

const Popover = componentWrapper<CustomPopoverFactory, IProps>("Popover", ({ middlewares, ...props }, _ref) => {
    return (
        <MantinePopover
            classNames={{ dropdown: styles["container"] }}
            {...props}
            // Merged rather than spread over, so a consumer passing its own `middlewares` adds to the
            // viewport fit instead of silently dropping it. Losing it while keeping the CSS that reads
            // `--overlay-available-height` would leave the dropdown with no cap at all.
            middlewares={{ ...OVERLAY_FIT_MIDDLEWARES, ...middlewares }}
        ></MantinePopover>
    );
});

Popover.Target = MantinePopover.Target;
Popover.Dropdown = MantinePopover.Dropdown;

export { Popover };
